import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCalendar, FiPackage } = FiIcons;

const UpcomingLaunchesTable = () => {
  const launchData = [
    {
      id: 1,
      productName: 'Eltrombopag Olamine Tablets',
      strengths: '12.5mg, 25mg, 50mg',
      innovatorBrand: 'Promacta',
      therapeuticCategory: 'Hematology',
      launchDate: '2026-02-12',
      launchType: 'Day 1 Launch',
      status: 'approved'
    },
    {
      id: 2,
      productName: 'Brivaracetam Tablets',
      strengths: '10mg, 25mg, 50mg, 75mg, 100mg',
      innovatorBrand: 'Briviact',
      therapeuticCategory: 'Neurology',
      launchDate: '2026-02-21',
      launchType: 'Day 181 Launch',
      status: 'pending'
    },
    {
      id: 3,
      productName: 'Mirabegron Tablets',
      strengths: '25mg, 50mg',
      innovatorBrand: 'Myrbetriq',
      therapeuticCategory: 'Urology',
      launchDate: '2026-02-23',
      launchType: 'FOF (Follow on filing)',
      status: 'development'
    },
    {
      id: 4,
      productName: 'Venetoclax Tablets',
      strengths: '10mg, 50mg, 100mg',
      innovatorBrand: 'Venclexta',
      therapeuticCategory: 'Oncology',
      launchDate: '2029-11-13',
      launchType: 'Day 1 for All',
      status: 'approved'
    },
  ];

  const getStatusColor = (status) => {
    const colors = {
      approved: 'bg-green-100 text-green-800',
      pending: 'bg-yellow-100 text-yellow-800',
      development: 'bg-blue-100 text-blue-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const getLaunchTypeColor = (type) => {
    const colors = {
      'Day 1 Launch': 'bg-green-100 text-green-800',
      'Day 181 Launch': 'bg-orange-100 text-orange-800',
      'FOF (Follow on filing)': 'bg-blue-100 text-blue-800',
      'Day 1 for All': 'bg-purple-100 text-purple-800'
    };
    return colors[type] || 'bg-gray-100 text-gray-800';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Product Name</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Strengths</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Innovator Brand</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Therapeutic Category</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Launch Date</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Launch Type</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Status</th>
          </tr>
        </thead>
        <tbody>
          {launchData.map((product, index) => (
            <motion.tr
              key={product.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
            >
              <td className="py-4 px-6">
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiPackage} className="text-blue-600" />
                  <div>
                    <p className="font-medium text-gray-900">{product.productName}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-6">
                <span className="text-sm text-gray-700">{product.strengths}</span>
              </td>
              <td className="py-4 px-6">
                <span className="font-medium text-gray-900">{product.innovatorBrand}</span>
              </td>
              <td className="py-4 px-6">
                <span className="text-gray-700">{product.therapeuticCategory}</span>
              </td>
              <td className="py-4 px-6">
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiCalendar} className="text-gray-400 text-sm" />
                  <span className="text-gray-700">{formatDate(product.launchDate)}</span>
                </div>
              </td>
              <td className="py-4 px-6">
                <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${getLaunchTypeColor(product.launchType)}`}>
                  {product.launchType}
                </span>
              </td>
              <td className="py-4 px-6">
                <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(product.status)}`}>
                  {product.status.charAt(0).toUpperCase() + product.status.slice(1)}
                </span>
              </td>
            </motion.tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UpcomingLaunchesTable;